import { connect } from 'react-redux'
import { compose } from 'redux';
import toJS from '../../../hoc/toJS.jsx';
import PageElbenwald from '../presents/PageElbenwald.jsx';
import { PROGRAM, PROGRAM_CLI_MOVIES_ITEMS, PROGRAM_CLI_MOVIES_ORDER, PROGRAM_ERROR, PROGRAM_META_MOVIES_ITEMS, PROGRAM_STATUS } from '../../../constants/state.js';
import getData from '../../../functions/getData.js';
import { programUpdateRequest } from '../../../actions/index.js';
import actionTypes from '../../../actions/actionTypes.js';

const mapStateToProps = state => ({
    movies: getData(state, PROGRAM_CLI_MOVIES_ITEMS),
    moviesOrder: getData(state, PROGRAM_CLI_MOVIES_ORDER),
    metaMovies: getData(state, PROGRAM_META_MOVIES_ITEMS),
    brands: state.getIn([PROGRAM, 'elbenwaldBrands', 'items']),
    programStatus: getData(state, PROGRAM_STATUS),
    programError: getData(state, PROGRAM_ERROR)
})

const mapDispatchToProps = dispatch => ({
    onUpdateBrandMovieMappings: (mappings)  => {
        dispatch(programUpdateRequest({
            actionRequest:  actionTypes.BRAND_MOVIE_MAPPINGS_UPDATE_REQUEST,
            actionError:    actionTypes.BRAND_MOVIE_MAPPINGS_UPDATE_ERROR,
            actionSuccess:  actionTypes.BRAND_MOVIE_MAPPINGS_UPDATE_SUCCESS,
            actionPayload:  { mappings: mappings }
        }))
    }
})

const PageElbenwaldContainer = ({goBackPath, moviesOrder, movies, metaMovies, brands, programStatus, programError, onUpdateBrandMovieMappings}) => {
    return <PageElbenwald
        movies={movies}
        moviesOrder={moviesOrder}
        metaMovies={metaMovies}
        brands={brands}
        goBackPath={goBackPath}
        programStatus={programStatus}
        programError={programError}
        onUpdateBrandMovieMappings={onUpdateBrandMovieMappings}
    />
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS(),
)(PageElbenwaldContainer)